import Vue from 'vue'
import Vuex from 'vuex'

import {AuthenticationDetails, CognitoUserPool, CognitoUser} from 'amazon-cognito-identity-js';

Vue.use(Vuex)

const poolData = {
  UserPoolId: process.env.VUE_APP_USER_POOL_ID,
  ClientId: process.env.VUE_APP_USER_POOL_CLIENT_ID
}

const userPool = new CognitoUserPool(poolData);

export default new Vuex.Store({
  state: {
    expTime: null,
    loggedInUser: undefined,
    authenticated: false,
    loginError: null,
    loginInProgress: false,
    infoItems: [],
    COGNITO_REGION: process.env.VUE_APP_COGNITO_REGION,
  },
  mutations: {
    'REMOVE_INFO_ITEM'(state, item_index){
      state.infoItems.splice(item_index, 1);
    },
    'REMOVE_INFO_ITEM_BY_OBJECT'(state, o_item){
      state.infoItems = state.infoItems.filter(item => item !== o_item);
    },
    'ADD_INFO_ITEM'(state, newItem){
      state.infoItems.push(newItem);
    }
  },
  actions: {
    // Trigger autentication towards cognito to get access to the application
    authenticate({state, dispatch}, authDetails){
      state.loginInProgress = true;
      let userData = {
        Username: authDetails.Username,
        Pool: userPool
      }
      // AWS.config.update({ region: state.COGNITO_REGION })
      let cognitoUser = new CognitoUser(userData);
      
      let authenticationData = {
        Username: authDetails.Username
      }

      var authenticationDetails = new AuthenticationDetails(authenticationData);
      cognitoUser.setAuthenticationFlowType('CUSTOM_AUTH')
      
      cognitoUser.username = authDetails.Username;

      cognitoUser.initiateAuth(authenticationDetails, {
        onSuccess: function (result) {
          let expTime = result.getAccessToken().getExpiration();
          state.expTime = new Date(expTime*1000)
          state.loggedInUser = cognitoUser;
          state.authenticated = true
          state.loginInProgress = false;
          window.location.replace(window.location.origin+process.env.VUE_APP_VERIFY_COOKIE_URL+'?acckey=' + result.getAccessToken().jwtToken)
        },
        customChallenge: function () {
          cognitoUser.sendCustomChallengeAnswer(authDetails.Password, this );
        },
        onFailure: function (err) {
          state.loginError = err.message;
          dispatch('addInfoItem', {'type': 'error', 'msg': err.message})
          state.loginInProgress = false;
        },
      })
    },
    removeInfoItem({commit}, index){
      commit('REMOVE_INFO_ITEM', index);
    },
    addInfoItem({commit}, newItem){
      newItem.timeout = Date.now();
      commit('ADD_INFO_ITEM', newItem);
      setTimeout(() => {
        commit('REMOVE_INFO_ITEM_BY_OBJECT', newItem);
      }, 5000);
    }
  },
  modules: {
  },
  getters: {
    userAccount(state){
      return state.loggedInUser;
    },
    getAccessToken(state){
      return state.loggedInUser.signInUserSession.accessToken;
    },
    loginError(state){
      return state.loginError;
    },
    infoItems(state){
      return state.infoItems;
    },
    loginInProgress(state){
      return state.loginInProgress;
    }
  }
})


